import { render } from "./support-modal.vue?vue&type=template&id=ca5f20c2&ts=true"
import script from "./support-modal.vue?vue&type=script&lang=ts"
export * from "./support-modal.vue?vue&type=script&lang=ts"

import "./support-modal.vue?vue&type=style&index=0&id=ca5f20c2&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__